import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Box, Text } from 'components/elements';
import * as S from './styles';

function OppTraining({ data }) {
  const isTrainingRequired = data;

  return (
    <S.OppTraining className="oppTraining">
      <Box paddingRight={12}>
        <Text className="training__text" as="span" variant="body2" colour="neutral.700">
          We will provide
        </Text>
      </Box>

      <Box>
        <Badge
          className="training__badge"
          colourScheme="green"
          size="sm"
          variant="ghost"
          textTransform="uppercase"
        >
          all training
        </Badge>
      </Box>
      {isTrainingRequired && (
        <Box paddingLeft={12}>
          <Badge
            className="training__badge"
            colourScheme="green"
            size="sm"
            variant="ghost"
            textTransform="uppercase"
          >
            Free DBS/PVG Certificate
          </Badge>
        </Box>
      )}
    </S.OppTraining>
  );
}

OppTraining.propTypes = {
  data: PropTypes.bool.isRequired,
};

export default OppTraining;
